import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-setting-payment-gateway-form',
  templateUrl: './setting-payment-gateway-form.component.html',
  styleUrls: ['./setting-payment-gateway-form.component.scss']
})
export class SettingPaymentGatewayFormComponent implements OnInit {

  constructor(private http: HttpService, private route: ActivatedRoute) { 
    this.init();
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));

    uuid.subscribe(async (val:any) => {
      await this.init()
      if(val) {
        await this.getData(val);
      } else {
        if(this.providers.length > 0) {
          this.fields = this.providers[0].fields;  
          this.data.provider_uuid = this.providers[0].uuid;
          this.selectedProviderType = this.providers[0].type || '';
          this.applyProviderDefaults();
        }
      }
    })
  }

  @ViewChild('f') f : NgForm;

  public fields: any = [];
  public providers: any = [];
  public data: any = {config: {}, status: 1};
  public banks: any = [];
  public selectedProviderType: string = '';
  public callbackUrls: any[] = [];
  public copiedUrl: string = '';
  public sky99Methods: any[] = [];
  public sky99MethodsError: string = '';
  public sky99MethodsLoading: boolean = false;
  public novapayDepositMethods: any[] = [
    { code: '10002', name: 'MYR FPX', min: 50, max: 30000, gateway_min_fee: 1 },
    { code: '10003', name: 'MYR QR', min: 10, max: 30000, gateway_min_fee: 0 },
    { code: '10004', name: 'MYR EWALLET', min: 10, max: 30000, gateway_min_fee: 0 },
  ];
  public novapayPayoutMethods: any[] = [
    { code: '1002', name: 'MYR PAYOUT', min: 100, max: 20000 },
  ];

  ngOnInit(): void {
  }

  async getData(uuid:any) {
    this.data = await this.http.post("/admin/payment-gateway/provider", {uuid: uuid});
    const provider = this.providers.find((p: any) => p.id == this.data.payment_gateway_provider_id);
    this.fields = provider.fields;
    this.selectedProviderType = provider.type || '';
    if (!this.data.config) this.data.config = {};
    if (!this.data.config.enabled_methods) this.data.config.enabled_methods = [];
    this.applyProviderDefaults();
  }

  async init() {
    let providers:any = await this.http.post("/admin/payment-gateway/provider/get");
    this.providers = providers.providers;

    let rtn:any = await this.http.post("/admin/bank/get");
    this.banks = rtn.banks;

  }

  async submit() {
    this.applyProviderDefaults();

    let rtn:any = await this.http.post("/admin/payment-gateway/provider/save", this.data);
    if(rtn.status) {
      this.http.navigate(['/lo',this.http.getStaticSelectedCompany(),'setting-payment-gateway']);
    } else {
      this.http.notify(rtn.message);
    }
  }

  async getField(event:any = null) {
    const provider = this.providers.find((p: any) => p.uuid == event.target.value);
    this.fields = provider.fields;
    this.selectedProviderType = provider.type || '';
    this.sky99Methods = [];
    this.sky99MethodsError = '';
    if (!this.data.config) this.data.config = {};
    this.data.config.enabled_methods = [];
    this.applyProviderDefaults();
  }

  shouldShowField(field: any): boolean {
    // sky99 gateway_code is selected per deposit by the player.
    if (this.selectedProviderType === 'sky99' && field.identifier === 'gateway_code') return false;

    // Novapay payout channel id is selected in the payout channel table.
    if (this.selectedProviderType === 'novapay' && field.identifier === 'outid') return false;

    return true;
  }

  // Providers whose callback URL is tenant-scoped and worth surfacing for copy.
  callbackUrlProviders = ['s1pay', 'primexpay', 'bbpay'];

  async loadCallbackUrls() {
    this.callbackUrls = [];
    if (!this.callbackUrlProviders.includes(this.selectedProviderType)) return;
    const rtn: any = await this.http.post("/admin/payment-gateway/callback-url", {
      type: this.selectedProviderType,
      config: this.data.config || {},
    });
    if (rtn && rtn.status && Array.isArray(rtn.urls)) {
      this.callbackUrls = rtn.urls.filter((u: any) => u && u.url);
    }
  }

  async copyCallbackUrl(url: string) {
    try {
      await navigator.clipboard.writeText(url);
    } catch (e) {
      // Fallback for non-secure contexts / older browsers.
      const el = document.createElement('textarea');
      el.value = url;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      try { document.execCommand('copy'); } catch (_) {}
      document.body.removeChild(el);
    }
    this.copiedUrl = url;
    setTimeout(() => { if (this.copiedUrl === url) this.copiedUrl = ''; }, 1500);
  }

  applyProviderDefaults() {
    if (!this.data.config) this.data.config = {};

    this.loadCallbackUrls();

    if (this.selectedProviderType === 'bbpay') {
      this.data.config.bbpay_p2p_rate ??= 1.1;
      this.data.config.bbpay_qr_rate ??= 1.5;
    }

    if (this.selectedProviderType === 'novapay') {
      this.data.config.outid = this.data.config.outid || '1002';
      this.data.config.currency = this.data.config.currency || 'MYR';
      if (this.data.config.gateway_withdraw_fee_rate == null && this.data.config.withdraw_rate != null) {
        this.data.config.gateway_withdraw_fee_rate = this.data.config.withdraw_rate;
      }
      this.ensureNovapayMethods();
    }
  }

  ensureNovapayMethods() {
    if (!this.data.config.enabled_methods) this.data.config.enabled_methods = [];

    this.data.config.enabled_methods = this.novapayDepositMethods.map(method => {
      const saved = this.data.config.enabled_methods.find((m: any) => String(m.code) === method.code) || {};
      return {
        code: method.code,
        name: method.name,
        gateway_fee_rate: saved.gateway_fee_rate ?? saved.rate ?? saved.topup_rate ?? 0,
        gateway_min_fee: saved.gateway_min_fee ?? saved.min_fee ?? method.gateway_min_fee ?? 0,
      };
    });

    if (!this.novapayPayoutMethods.some(method => method.code === String(this.data.config.outid))) {
      this.data.config.outid = this.novapayPayoutMethods[0].code;
    }
  }

  getNovapayMethodGatewayFeeRate(code: string): number {
    const method = (this.data.config.enabled_methods || []).find((m: any) => String(m.code) === code);
    return method ? (method.gateway_fee_rate ?? method.rate ?? method.topup_rate ?? 0) : 0;
  }

  setNovapayMethodGatewayFeeRate(code: string, value: string) {
    this.ensureNovapayMethods();
    const method = (this.data.config.enabled_methods || []).find((m: any) => String(m.code) === code);
    if (method) method.gateway_fee_rate = parseFloat(value) || 0;
  }

  getNovapayMethodGatewayMinFee(code: string): number {
    const method = (this.data.config.enabled_methods || []).find((m: any) => String(m.code) === code);
    return method ? (method.gateway_min_fee ?? method.min_fee ?? 0) : 0;
  }

  setNovapayMethodGatewayMinFee(code: string, value: string) {
    this.ensureNovapayMethods();
    const method = (this.data.config.enabled_methods || []).find((m: any) => String(m.code) === code);
    if (method) method.gateway_min_fee = parseFloat(value) || 0;
  }

  async loadSky99Methods() {
    this.sky99MethodsLoading = true;
    this.sky99MethodsError = '';
    const rtn: any = await this.http.post("/admin/payment-gateway/sky99/methods", { config: this.data.config });
    this.sky99MethodsLoading = false;
    if (!rtn || rtn.status === false) {
      this.sky99MethodsError = rtn?.message || 'Failed to load methods.';
      return;
    }
    // Sky99 returns { gateways: ["MAYBANK", "RHB", ...], gateway_qr: ["QR"], ... }
    // Normalise all string arrays into {code, name} objects
    const toItems = (arr: any) => Array.isArray(arr) ? arr.map((s: string) => ({ code: s, name: s })) : [];
    this.sky99Methods = [...toItems(rtn.gateways), ...toItems(rtn.gateway_qr)];
  }

  isSky99MethodEnabled(code: string): boolean {
    return (this.data.config.enabled_methods || []).some((m: any) => m.code === code);
  }

  toggleSky99Method(method: any, checked: boolean) {
    if (!this.data.config.enabled_methods) this.data.config.enabled_methods = [];
    if (checked) {
      if (!this.isSky99MethodEnabled(method.code)) {
        this.data.config.enabled_methods.push({
          code: method.code,
          name: method.name,
          gateway_fee_rate: 0,
          gateway_withdraw_fee_rate: 0
        });
      }
    } else {
      this.data.config.enabled_methods = this.data.config.enabled_methods.filter((m: any) => m.code !== method.code);
    }
  }

  getSky99MethodRate(code: string): number {
    const m = (this.data.config.enabled_methods || []).find((m: any) => m.code === code);
    return m ? (m.gateway_fee_rate ?? m.rate ?? 0) : 0;
  }

  setSky99MethodRate(code: string, value: string) {
    const m = (this.data.config.enabled_methods || []).find((m: any) => m.code === code);
    if (m) m.gateway_fee_rate = parseFloat(value) || 0;
  }

  getSky99MethodWithdrawRate(code: string): number {
    const m = (this.data.config.enabled_methods || []).find((m: any) => m.code === code);
    return m ? (m.gateway_withdraw_fee_rate ?? m.withdraw_rate ?? 0) : 0;
  }

  setSky99MethodWithdrawRate(code: string, value: string) {
    const m = (this.data.config.enabled_methods || []).find((m: any) => m.code === code);
    if (m) m.gateway_withdraw_fee_rate = parseFloat(value) || 0;
  }

  upload(data:any, key:string, single = false) {
    this.data.config[key] = (single) ? data[0] : data
  }

  delete(data:any, key:string) {
    this.data.config[key] = data
  }

  uploadDirect(data:any, key:string, single = false) {
    this.data[key] = (single) ? data[0] : data
  }

  deleteDirect(data:any, key:string) {
    this.data[key] = data
  }

  editorCreated(quill: any, param:any) {
    setTimeout(() => {
      quill.clipboard.dangerouslyPasteHTML(this.data.config[param]);
    }, 1000)
  }
}
